export const  small_screen = '540px';
export const  medium_screen = '992px';
